export { default } from "./ScrollFrame"
